import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSpinner } from '@fortawesome/free-solid-svg-icons';

const CancelSeriesModal = ({ isOpen, onClose, onConfirm, seriesNo, seriesNoUid, loading }) => {
  const [reason, setReason] = useState('');

  if (!isOpen) return null;

  const handleSubmit = () => {
    if (!reason.trim()) {
      alert('Please provide a reason for cancellation.');
      return;
    }
    onConfirm(seriesNoUid, reason);
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300 ease-in-out">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md transform transition-all duration-300 scale-100 sm:scale-95">
        <div className="p-6 border-b border-gray-100">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold text-gray-800">
              Cancel Series: {seriesNo}
            </h2>
            <button
              onClick={onClose}
              className="text-gray-600 hover:text-gray-800 text-lg"
              disabled={loading}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        </div>
        <div className="p-6">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Reason for Cancellation</label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              rows={6}
              className="w-full text-sm text-gray-600 border border-gray-300 rounded-lg p-2 resize-none focus:outline-none focus:ring-2 focus:ring-indigo-500"
              placeholder="Enter reason for cancellation..."
              disabled={loading}
            />
          </div>
        </div>
        <div className="p-6 border-t border-gray-100 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 disabled:bg-gray-300 disabled:cursor-not-allowed"
            disabled={loading}
          >
            Close
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 text-sm text-white bg-red-600 rounded-lg hover:bg-red-700 disabled:bg-red-400 disabled:cursor-not-allowed flex items-center gap-2"
            disabled={loading}
          >
            {loading && <FontAwesomeIcon icon={faSpinner} spin />}
            Cancel Series
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelSeriesModal;